export const generateApisToasterMessageIdByType = (type: 'success' | 'error'): string => `apis-update-${type}`;
